export type MaintenanceStatus = 'off' | 'degraded' | 'disabled'

export const MAINTENANCE_OFF: MaintenanceStatus = 'off'

const VALID_MAINTENANCE_STATUSES = new Set<MaintenanceStatus>([
  'off',
  'degraded',
  'disabled',
])

export function normalizeMaintenanceStatus(value: unknown): MaintenanceStatus {
  if (typeof value !== 'string') {
    return MAINTENANCE_OFF
  }

  const normalized = value.toLowerCase() as MaintenanceStatus
  return VALID_MAINTENANCE_STATUSES.has(normalized)
    ? normalized
    : MAINTENANCE_OFF
}

// Registry of feature keys that can be gated independently of the app-wide
// status. Adding a new gated feature only means adding a key here plus a
// FEATURE_<KEY>_STATUS env var — no other contract change needed.
export const FEATURE_KEYS = {
  DOCUMENTS: 'documents',
  GLOSSARIES: 'glossaries',
  TRANSLATION_MEMORY: 'translation_memory',
  DICTIONARIES: 'dictionaries',
  TEXT_POLISHER: 'text_polisher',
  TEXT_TRANSLATOR: 'text_translator',
} as const

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS]

export interface MaintenanceScopeState {
  status: MaintenanceStatus
  message?: string
  eta?: string
}

export type AppMaintenanceState = MaintenanceScopeState

export interface MaintenanceStatusResponse {
  app: AppMaintenanceState
  features: Record<string, MaintenanceScopeState>
  pollIntervalSeconds: number
}

export const DEFAULT_MAINTENANCE_POLL_INTERVAL_SECONDS = 30

export const OFF_MAINTENANCE_RESPONSE: MaintenanceStatusResponse = {
  app: { status: MAINTENANCE_OFF },
  features: {},
  pollIntervalSeconds: DEFAULT_MAINTENANCE_POLL_INTERVAL_SECONDS,
}
